import PageContextProvider from '@/components/page-context-provider/page-context-provider';
import React from 'react';

const gatsbyWrapPage = ({ element, props }) => {
  return <PageContextProvider pageContext={props.pageContext}>{element}</PageContextProvider>;
};

export default gatsbyWrapPage;